<template>
  <div style="width: 100%;" v-if="entities.length">
    <div @click="toggleRow()" class="clauserow">
      <div class="clauserowheader group">
        <div class="text-block-4">{{ group.name }}</div>
      </div>
    </div>
    <div ref="row" style="display: none;">
      <div v-for="e of entities" :key="e.id">
        <component
          :is="row"
          :clause="e"
          :contract="e"
          :group="group"
          @sharePressed="c => $emit('sharePressed', c)"
        ></component>
      </div>
    </div>
  </div>
</template>
<script>
import searchmixin from '@/components/mixins/search.mixin'
import Clause from './OverviewClauseItem'
import Contract from './OverviewContractItem'
export default {
  mixins: [searchmixin],
  props: {
    clauses: {
      type: Array,
      default () {
        return []
      }
    },
    contracts: {
      type: Array,
      default () {
        return []
      }
    },
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      toggle: true
    }
  },
  computed: {
    entities () {
      if (!this.group) {
        return []
      }
      return this.group.entities.map(this.getEntity).filter(e => e.id)
    },
    row () {
      if (this.group.type === 'CLAUSE') {
        return Clause
      }
      return Contract
    }
  },
  methods: {
    getEntity (id) {
      if (this.group.type === 'CLAUSE') {
        const filtered = this.clauses.filter(c => c.id === id)
        if (filtered && filtered.length) {
          return filtered[0]
        }
        return {}
      }
      const filtered = this.contracts.filter(c => c.id === id)
      if (filtered && filtered.length) {
        return filtered[0]
      }
      return {}
    },
    toggleRow () {
      if (this.toggle) {
        this.$refs.row.style.display = ''
      } else {
        this.$refs.row.style.display = 'none'
      }
      this.toggle = !this.toggle
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Group.vue